module.exports = __webpack_public_path__ + "img/notification.0be665a5.svg";